import watermarks from "./maturaPdfWatermarks.json";
import versions from "./maturaPdfVersions.json";

function resolvePdf(url) {
  if (!url?.startsWith("/assets/matura/")) return url;
  const parsed = new URL(url, "https://matematron.pl");
  const branded = watermarks[parsed.pathname] || (versions[parsed.pathname] ? parsed.pathname : null);
  if (!branded) return url;
  parsed.pathname = branded;
  if (versions[branded]) parsed.searchParams.set("v", versions[branded]);
  return parsed.pathname + parsed.search + parsed.hash;
}

export function brandedMaturaPdfUrl(url) {
  if (!url) return url;
  if (!url.startsWith("/pdfjs/web/viewer.html?")) return resolvePdf(url);
  const parsed = new URL(url, "https://matematron.pl");
  const original = parsed.searchParams.get("file");
  const branded = resolvePdf(original);
  if (branded === original) return url;
  parsed.searchParams.set("file", branded);
  return parsed.pathname + parsed.search + parsed.hash;
}
